module.exports = __webpack_public_path__ + "static/24hour-0f9edc58d4bf36e254d7d810d3e065fd.png";